import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaUser,
  FaPaperPlane,
} from "react-icons/fa";

const Contact = () => {
  return (
    <div className="contact-page">
      {/* ── PAGE HERO ── */}
      <section className="about-hero">
        <div className="about-hero-bg" />
        <div className="container">
          <div className="about-hero-inner">
            <p className="about-eyebrow">Get in Touch</p>
            <h1>
              Contact Our <span>Foundation</span>
            </h1>
            <p className="about-hero-sub">
              Reach out to Geetha Alagappan Foundation for inquiries, support,
              or to join our mission in making a positive impact.
            </p>
          </div>
        </div>
      </section>

      {/* ── CONTACT SECTION ── */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            {/* ── LEFT: INFO ── */}
            <div className="contact-info">
              <p className="contact-eyebrow">Get in Touch</p>
              <h2>
                Let's <span>Talk</span>
              </h2>
              <p className="contact-intro">
                If you need support, have questions, or wish to contribute
                towards our initiatives, our foundation team is always here to
                help.
              </p>

              <div className="contact-items">
                <div className="contact-item">
                  <div className="contact-item-icon">
                    <FaPhoneAlt />
                  </div>
                  <div>
                    <h5>Phone</h5>
                    <p>+91 99444 41205</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-item-icon">
                    <FaEnvelope />
                  </div>
                  <div>
                    <h5>Email</h5>
                    <p>info@geethaalagappanfoundation.org</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-item-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div>
                    <h5>Address</h5>
                    <p>
                      Karaikudi, Tamil Nadu, India
                      <br />
                      Tamil Nadu – 630001
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* ── RIGHT: FORM ── */}
            <div className="contact-form-wrap">
              <div className="contact-form-header">
                <p className="contact-eyebrow light">Send a Message</p>
                <h2>
                  Connect <span>With Us</span>
                </h2>
              </div>

              <form className="contact-form">
                <div className="form-row">
                  <div className="input-field">
                    <FaUser />
                    <input type="text" placeholder="Full Name" required />
                  </div>
                  <div className="input-field">
                    <FaPhoneAlt />
                    <input type="tel" placeholder="Mobile Number" required />
                  </div>
                </div>

                <div className="input-field">
                  <FaEnvelope />
                  <input type="email" placeholder="Email Address" required />
                </div>

                <textarea rows="5" placeholder="Your message..." required />

                <button type="submit">
                  <FaPaperPlane /> Send Message
                </button>
              </form>
            </div>
          </div>

          {/* ── MAP ── */}
          <div className="contact-map">
            <div className="contact-map-label">
              <FaMapMarkerAlt /> Karaikudi, Tamil Nadu
            </div>
            <iframe
              title="Foundation Location"
              src="https://www.google.com/maps?q=Karaikudi&output=embed"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
